import { styled } from "@mui/material/styles";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  "&.datePickerWithEndAdorment": {
    margin: theme.spacing(1),
    width: "100%"
  }
}));

export const StyledDatePicker = styled(DatePicker)(({ theme }) => {
  const light = theme.palette.type === "light";
  const placeholder = {
    color: "#86868b",
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.shorter
    })
  };
  const placeholderHidden = {
    opacity: "0 !important"
  };
  const placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    "& .MuiInputBase-root": {
      borderRadius: "10px",
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "22px",
      letterSpacing: "0.08px",
      color: "#2C2C2C",
      backgroundColor: "#FFF",
      border: "0",
      borderStyle: "solid",
      borderColor: "#BCBDC0",
      "&.warning": {
        borderColor: "#ea991d"
      },
      "&:hover": {
        backgroundColor: "#FFF"
      },
      "&.Mui-focused": {
        backgroundColor: "#FFF"
      },
      "&.Mui-disabled": {
        backgroundColor: "#F2F2F2"
      },
      "&.Mui-error": {
        borderColor: "#ea2b1e"
      },
      "&:focus-within": {
        borderColor: "var(--Color-Text-Primary-On-Light, #1F1F1F)"
      }
    },
    "& .MuiInputBase-input": {
      padding: "25px 20px 8px",
      borderRadius: "10px",
      border: "none",
      height: "22px",
      "&::placeholder": placeholder,
      "&::-webkit-input-placeholder": placeholder,
      "&::-moz-placeholder": placeholder,
      "&:-ms-input-placeholder": placeholder,
      "&::-ms-input-placeholder": placeholder,
      "label[data-shrink=false] + .MuiInputBase-formControl &": {
        "&::-webkit-input-placeholder": placeholderHidden,
        "&::-moz-placeholder": placeholderHidden,
        "&:-ms-input-placeholder": placeholderHidden,
        "&::-ms-input-placeholder": placeholderHidden,
        "&:focus::-webkit-input-placeholder": placeholderVisible,
        "&:focus::-moz-placeholder": placeholderVisible,
        "&:focus:-ms-input-placeholder": placeholderVisible,
        "&:focus::-ms-input-placeholder": placeholderVisible
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      top: 0
    },
    "& .MuiInputLabel-root": {
      color: "var(--Color-Text-Primary-On-Light)",
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.08px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      transform: "translate(20px, 16px) scale(1)"
    },
    "& .MuiInputLabel-shrink": {
      fontWeight: 500,
      fontSize: "0.875rem",
      transform: "translate(20px, 7px) scale(0.75)",
      color: "var(--colour-text-secondary)"
    },
    "& .MuiIconButton-root": {
      marginRight: 0,
      "& svg": {
        width: "24px",
        height: "24px",
        color: "var(--Color-Text-Primary-On-Light)"
      }
    },
    "& legend": {
      display: "none"
    }
  };
});
